import './Game.scss';
import MonsterAvatar from './MonsterAvatar';
import MonsterBlackjack from './MonsterBlackjack';

function MonsterArea() {
  return (
      <div className="monster-area">
        <MonsterAvatar />
        <MonsterBlackjack />
      </div>
  );
}

export default MonsterArea;
